import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  Row,
  Container,
  CardHeader,
  Col,
  CardBody,
  CardTitle,
  NavItem,
  TabContent,
  NavLink,
  Nav,
  CardText,
  Button,
  Table,
  FormGroup,
  FormText,
  Form,
  Input,
  Label,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  TabPane,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Dropdown,
  CardFooter,
} from "reactstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import tutorsModal from "models/tutors.modal";
import DeviceUUID from "device-uuid";
import { helper } from "lib/helper";
import SubAdminModal from "models/user.modal";
import moment from "moment";
import levelModal from "models/level.modal";

const Editprofile = ({ dataList, toggle, profile, getTutorsProfileData }) => {
  const [isChecked, setIsChecked] = useState(profile?.verified);

  const handleCheckboxChange = () => {
    setIsChecked((prev) => !prev);
  };

  const [inputsPro, setInputsPro] = useState(
    profile?.professional_experience?.map((value, index) => ({
      id: index,
      value,
    }))
  );

  const inputsProvalues = inputsPro && inputsPro?.map((item) => item.value);

  const handleInputChangePro = (index, event) => {
    const values = [...inputsPro];
    values[index].value = event.target.value;
    setInputsPro(values);
  };

  const handleAddInputPro = () => {
    const newInputs = [...inputsPro, { id: inputsPro.length, value: "" }];
    setInputsPro(newInputs);
  };

  const handleRemoveInputPro = (index) => {
    if (inputsPro.length === 1) return; // Don't delete if only one input field is there
    const values = [...inputsPro];
    values.splice(index, 1);
    setInputsPro(values);
  };

  const [inputsTech, setInputsTech] = useState(
    profile?.teaches?.map((value, index) => ({ id: index, value }))
  );

  const handleInputChangeTech = (index, event) => {
    const values = [...inputsTech];
    values[index].value = event.target.value;
    setInputsTech(values);
  };
  const inputsTechvalues = inputsTech && inputsTech?.map((item) => item.value);
  const handleAddInputTech = () => {
    const newInputs = [
      ...inputsTech,
      { id: inputsTech && inputsTech?.length + 1, value: "" },
    ];
    setInputsTech(newInputs);
  };
  const handleRemoveInputTech = (index) => {
    if (inputsTech && inputsTech?.length === 1) return; // Don't delete if only one input field is there
    const values = [...inputsTech];
    values.splice(index, 1);
    setInputsTech(values);
  };

  const [inputsBoards, setInputsBoards] = useState(
    profile?.boards?.map((value, index) => ({ id: index, value }))
  );

  const handleInputChangeBoords = (index, event) => {
    const values = [...inputsBoards];
    values[index].value = event.target.value;
    setInputsBoards(values);
  };
  const inputsBoardsvalues =
    inputsBoards && inputsBoards?.map((item) => item.value);
  const handleAddInputBoords = () => {
    const newInputs = [
      ...inputsBoards,
      { id: inputsBoards && inputsBoards?.length + 1, value: "" },
    ];
    setInputsBoards(newInputs);
  };
  const handleRemoveInputBoords = (index) => {
    if (inputsBoards && inputsBoards?.length === 1) return; // Don't delete if only one input field is there
    const values = [...inputsBoards];
    values.splice(index, 1);
    setInputsBoards(values);
  };

  const [inputsGrade, setInputsGrade] = useState(
    profile?.grade?.map((value, index) => ({ id: index, value }))
  );
  const handleInputChangeGrade = (index, event) => {
    const values = [...inputsGrade];
    values[index].value = event.target.value;
    setInputsGrade(values);
  };
  const inputsGradevalues =
    inputsGrade && inputsGrade?.map((item) => item.value);
  const handleAddInputGrades = () => {
    const newInputs = [
      ...inputsGrade,
      { id: inputsGrade && inputsGrade?.length + 1, value: "" },
    ];
    setInputsGrade(newInputs);
  };
  const handleRemoveInputGrade = (index) => {
    if (inputsGrade && inputsGrade?.length === 1) return; // Don't delete if only one input field is there
    const values = [...inputsGrade];
    values.splice(index, 1);
    setInputsGrade(values);
  };

  const [inputsEducation, setInputsEducation] = useState(
    profile?.education?.map((value, index) => ({ id: index, value }))
  );
  const handleInputChangeEducation = (index, value) => {
    const values = [...inputsEducation];
    values[index] = { ...values[index], value }; // Update the value at the specified index
    setInputsEducation(values);
  };
  const inputsEducationvalues =
    inputsEducation && inputsEducation?.map((item) => item.value);
  const handleAddInputEducation = () => {
    const newInputs = [
      ...inputsEducation,
      { id: inputsEducation && inputsEducation?.length + 1, value: "" },
    ];
    setInputsEducation(newInputs);
  };
  const handleRemoveInputEducation = (index) => {
    if (inputsEducation && inputsEducation?.length === 1) return; // Don't delete if only one input field is there
    const values = [...inputsEducation];
    values.splice(index, 1);
    setInputsEducation(values);
  };

  const [formData, setFormData] = useState({
    verified: "",
    stars: profile?.stars,
    description: profile?.description,
    Year_Of_Exprinace: profile && profile?.teaching_experience[0],
    student_throught: profile && profile?.teaching_experience[1],
    about: profile?.about,
    status: profile?.starts,
    vehicle: profile?.vehicle,
    english_fluency: profile?.english_fluency,
    age:profile?.age
  });

  // input valu change in formdata
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value, // Store the value in the state
    }));
  };

  const handleInputChangeCheckbox = (e) => {
    const { name, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: checked, // Store the checked state of the checkbox in the state
    }));
  };

  const [selectLevel, setSelectdLevel] = useState("");
  const handleSelectStatus = (id) => {
    setSelectdLevel(id);
  };

  const navigate = useNavigate();
  const params = useParams();
  const handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      id: profile?.id,
      // tutor: parseInt(params.mid),
      //   tutor: parseInt(params.mid),
      verified: isChecked,
      stars: parseInt(formData.stars),
      description: formData.description,
      teaching_experience: [
        formData.Year_Of_Exprinace,
        formData.student_throught,
      ],
      professional_experience: inputsProvalues,
      about: formData.about,
      teaches: inputsTechvalues,
      boards: inputsBoardsvalues,
      grade: inputsGradevalues,
      education: inputsEducationvalues,
      vehicle: formData.vehicle,
      english_fluency: formData.english_fluency,
      level: parseInt(selectLevel),
      age:formData.age
    };
    tutorsModal
      .editTutorsProfile(data)
      .then((response) => {
        toggle();
        helper.sweetalert.toast(response.message, "success");
        getTutorsProfileData();

        // Display success message to the user
      })
      .catch((error) => {
        // console.log(error);
      });
  };
  // const [modal, setModal] = useState(false);
  // const toggle = () => setModal(!modal);

  //   const [profile, setProfile] = useState("");

  //   const getTutorsProfileData = async (id) => {
  //     await tutorsModal
  //       .TutorsProfileGet(params.mid)
  //       .then((result) => {
  //         if (result) {
  //           setProfile(result?.data?.data);
  //         }
  //       })
  //       .catch((error) => {});
  //   };
  //   useEffect(() => {
  //     getTutorsProfileData();
  //   }, []);


  const [ListLevel, setListLevel] = useState([]);
  const getListDataLevel = async () => {
    await levelModal
      .list()
      .then((result) => {
        if (result) {
          setListLevel(result?.data);
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    getListDataLevel();
  }, []);

  return (
    <div>
      <Card
        style={{
          width: "100%",
        }}
        className="mt-2"
      >
        <CardHeader className="p-2 ml-3">
          <h3 className="mb-0" style={{ color: "black" }}>
            Edit Profile
          </h3>
        </CardHeader>
        <CardBody
          style={{
            height: "80vh",
            overflowY: "scroll",
          }}
        >
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={4}>
                <FormGroup>
                  <Label for="exampleEmail">Name</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    id="name"
                    placeholder="Name"
                    defaultValue={`${dataList?.user?.first_name} ${dataList?.user?.last_name}`}
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup>
                  <Label for="exampleEmail">Age</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    id="name"
                    name="age"
                    placeholder="Enter Age"
                    value={formData?.age}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
              <Col md={4}>
                <Label check for="exampleEmail" className="mb-0">
                  Status
                </Label>
                <FormGroup check className="mb-0 mr-2">
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      // padding: "6px 10px",
                      height: "30px",
                      width: "25px",
                      borderRadius: "6px",
                      marginTop: "10px",
                    }}
                    type="checkbox"
                    id="name"
                    name="question"
                    placeholder="Mode of Tuition"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                    // defaultChecked={profile?.verified}
                  />
                </FormGroup>
                <p className="ml-6 mb-0 mt-3">
                  {isChecked ? (
                    <span style={{ color: "green", fontWeight: "bold" }}>
                      Verified
                    </span>
                  ) : (
                    <span style={{ color: "red", fontWeight: "bold" }}>
                      Unverified
                    </span>
                  )}
                </p>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <p
                  style={{
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "lightgray",
                  }}
                >
                  Teaching Exprinace
                </p>{" "}
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Year Of Exprinace</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    value={formData.Year_Of_Exprinace}
                    onChange={handleInputChange}
                    name="Year_Of_Exprinace"
                    placeholder=" Enter Teaching Exprinace"
                    // defaultValue={`${dataList?.state || "-"}/${dataList?.city || '-'}`}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="exampleEmail">Student Taught</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    id="name"
                    value={formData.student_throught}
                    onChange={handleInputChange}
                    placeholder=" Enter Student"
                    name="student_throught"
                    // defaultValue={`${dataList?.state || "-"}/${dataList?.city || '-'}`}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Level</Label>
                  <Input
                    id="forType"
                    type="select"
                    onChange={(e) => {
                      handleSelectStatus(e.target.value, "board");
                    }}
                  >
                    <option value="">select Option</option>
                    {ListLevel &&
                      ListLevel.map((item) => (
                        <option
                          key={item.id}
                          value={item.id}
                          selected={profile?.level === item.name}
                        >
                          {item.name}
                        </option>
                      ))}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">Description</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    id="name"
                    type="textarea"
                    placeholder="Enter Description"
                    value={formData.description}
                    onChange={handleInputChange}
                    name="description"
                    // defaultValue={dataList?.mobile}
                  />
                </FormGroup>
              </Col>
            </Row>
            {/* </Row> */}

            <Row>
              <Col md={12}>
                <Label for="exampleEmail">Professional Experience</Label>
                {inputsPro?.map((input, index) => (
                  <div key={input.id}>
                    <Input
                      type="textarea"
                      placeholder="Enter Professional Experience"
                      value={input.value}
                      onChange={(event) => handleInputChangePro(index, event)}
                      className="mt-2"
                    />
                    {index !== 0 && ( // Don't show delete button for first input field
                      <i
                        className="fa-solid fa-xmark"
                        color="danger"
                        onClick={() => handleRemoveInputPro(index)}
                        style={{
                          float: "right",
                          fontSize: "20px",
                          color: "red",
                          marginBottom: "20px",
                        }}
                      />
                    )}
                  </div>
                ))}
                <Row>
                  <Col md={12} style={{ fontSize: "20px", float: "right" }}>
                    <i
                      className="fa-solid fa-plus"
                      onClick={handleAddInputPro}
                      style={{
                        float: "right",
                        fontSize: "20px",
                        color: "blue",
                      }}
                    ></i>{" "}
                    {/* Plus icon to add rows */}
                  </Col>
                </Row>
              </Col>
            </Row>
            <hr />

            <Row>
              <Col md={12}>
                <Label for="exampleEmail">Teaches </Label>
                {inputsTech?.map((input, index) => (
                  <div key={input.id}>
                    <Input
                      type="textarea"
                      placeholder="Enter Professional Experience"
                      value={input.value}
                      onChange={(event) => handleInputChangeTech(index, event)}
                      className="mt-2"
                    />
                    {index !== 0 && ( // Don't show delete button for first input field
                      <i
                        className="fa-solid fa-xmark"
                        color="danger"
                        onClick={() => handleRemoveInputTech(index)}
                        style={{
                          float: "right",
                          fontSize: "20px",
                          color: "red",
                          marginBottom: "20px",
                        }}
                      />
                    )}
                  </div>
                ))}
                <Row>
                  <Col md={12} style={{ fontSize: "20px", float: "right" }}>
                    <i
                      className="fa-solid fa-plus"
                      onClick={handleAddInputTech}
                      style={{
                        float: "right",
                        fontSize: "20px",
                        color: "blue",
                      }}
                    ></i>{" "}
                    {/* Plus icon to add rows */}
                  </Col>
                </Row>
              </Col>
            </Row>

            <hr />

            <Row>
              <Col md={12}>
                <Label for="exampleEmail">Boards </Label>
                {inputsBoards?.map((input, index) => (
                  <div key={input.id}>
                    <Input
                      type="textarea"
                      placeholder="Enter Boards"
                      value={input.value}
                      onChange={(event) =>
                        handleInputChangeBoords(index, event)
                      }
                      className="mt-2"
                    />
                    {index !== 0 && ( // Don't show delete button for first input field
                      <i
                        className="fa-solid fa-xmark"
                        color="danger"
                        onClick={() => handleRemoveInputBoords(index)}
                        style={{
                          float: "right",
                          fontSize: "20px",
                          color: "red",
                          marginBottom: "20px",
                        }}
                      />
                    )}
                  </div>
                ))}
                <Row>
                  <Col md={12} style={{ fontSize: "20px", float: "right" }}>
                    <i
                      className="fa-solid fa-plus"
                      onClick={handleAddInputBoords}
                      style={{
                        float: "right",
                        fontSize: "20px",
                        color: "blue",
                      }}
                    ></i>{" "}
                    {/* Plus icon to add rows */}
                  </Col>
                </Row>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col md={12}>
                <Label for="exampleEmail">Grade </Label>
                {inputsGrade.map((input, index) => (
                  <div key={input.id}>
                    <Input
                      type="textarea"
                      placeholder="Enter Grade"
                      value={input.value}
                      onChange={(event) => handleInputChangeGrade(index, event)}
                      className="mt-2"
                    />
                    {index !== 0 && ( // Don't show delete button for first input field
                      <i
                        className="fa-solid fa-xmark"
                        color="danger"
                        onClick={() => handleRemoveInputGrade(index)}
                        style={{
                          float: "right",
                          fontSize: "20px",
                          color: "red",
                          marginBottom: "20px",
                        }}
                      />
                    )}
                  </div>
                ))}
                <Row>
                  <Col md={12} style={{ fontSize: "20px", float: "right" }}>
                    <i
                      className="fa-solid fa-plus"
                      onClick={handleAddInputGrades}
                      style={{
                        float: "right",
                        fontSize: "20px",
                        color: "blue",
                      }}
                    ></i>{" "}
                    {/* Plus icon to add rows */}
                  </Col>
                </Row>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col md={12}>
                <Label for="exampleEmail">Education </Label>
                {inputsEducation.map((input, index) => (
                  <div key={input.id}>
                    <Input
                      type="textarea"
                      placeholder="Enter Education"
                      value={input.value}
                      onChange={(event) =>
                        handleInputChangeEducation(index, event.target.value)
                      }
                      className="mt-2"
                    />
                    {index !== 0 && ( // Don't show delete button for first input field
                      <i
                        className="fa-solid fa-xmark"
                        color="danger"
                        onClick={() => handleRemoveInputEducation(index)}
                        style={{
                          float: "right",
                          fontSize: "20px",
                          color: "red",
                          marginBottom: "20px",
                        }}
                      />
                    )}
                  </div>
                ))}
                <Row>
                  <Col md={12} style={{ fontSize: "20px", float: "right" }}>
                    <i
                      className="fa-solid fa-plus"
                      onClick={handleAddInputEducation}
                      style={{
                        float: "right",
                        fontSize: "20px",
                        color: "blue",
                      }}
                    ></i>{" "}
                    {/* Plus icon to add rows */}
                  </Col>
                </Row>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="exampleEmail">About</Label>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      padding: "6px 10px",
                      borderRadius: "6px",
                    }}
                    id="name"
                    value={formData.about}
                    onChange={handleInputChange}
                    placeholder="Enter About"
                    type="textarea"
                    name="about"
                    // defaultValue={dataList.referral || '-'}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Label check for="exampleEmail" className="mb-0">
                  Star
                </Label>
                <FormGroup>
                  <Input
                    style={{
                      border: "1px solid lightgrey",
                      borderRadius: "6px",
                      marginTop: "10px",
                    }}
                    type="number"
                    id="name"
                    name="stars"
                    placeholder="Enter Start"
                    value={formData.stars}
                    onChange={handleInputChange}
                    maxLength={5}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Label check for="exampleEmail" className="mb-0">
                  Vehicle
                </Label>
                <FormGroup check className="mb-0 mr-2">
                  <input
                    style={{
                     
                      height: "25px",
                      width: "25px",
                     
                      marginTop: "10px",
                    }}
                    type="checkbox"
                    id="name"
                    name="vehicle"
                    placeholder="Mode of Tuition"
                    value={formData.vehicle}
                    onChange={handleInputChangeCheckbox}
                    defaultChecked={profile?.vehicle}
                  />
                </FormGroup>
              </Col>

              <Col md={6}>
                <Label check for="exampleEmail" className="mb-0">
                  Englist Fluency
                </Label>
                <FormGroup  className="mb-0 mr-2">
                  <Input
                    type="text"
                    id="name"
                    name="english_fluency"
                    placeholder="Mode of Tuition"
                    value={formData.english_fluency}
                    onChange={handleInputChange}
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <Button
                  color="primary"
                  type="submit"
                  style={{ float: "right", marginLeft: "5%" }}
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
};

export default Editprofile;
